import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';

// Países en español
const NOMBRE_ES = {
  'Mexico': 'México', 'South Africa': 'Sudáfrica', 'Korea Republic': 'Corea del Sur',
  'Czechia': 'Rep. Checa', 'Canada': 'Canadá', 'Bosnia-Herzegovina': 'Bosnia',
  'USA': 'EE.UU.', 'Paraguay': 'Paraguay', 'Qatar': 'Qatar', 'Switzerland': 'Suiza',
  'Brazil': 'Brasil', 'Morocco': 'Marruecos', 'Haiti': 'Haití', 'Scotland': 'Escocia',
  'Australia': 'Australia', 'Turkey': 'Turquía', 'Germany': 'Alemania',
  'Curaçao': 'Curazao', 'Netherlands': 'Países Bajos', 'Japan': 'Japón',
  "Côte d'Ivoire": 'Costa de Marfil', 'Ecuador': 'Ecuador', 'Sweden': 'Suecia',
  'Tunisia': 'Túnez', 'Spain': 'España', 'Cabo Verde': 'Cabo Verde',
  'Belgium': 'Bélgica', 'Egypt': 'Egipto', 'Saudi Arabia': 'Arabia Saudita',
  'Uruguay': 'Uruguay', 'IR Iran': 'Irán', 'New Zealand': 'Nueva Zelanda',
  'France': 'Francia', 'Senegal': 'Senegal', 'Iraq': 'Irak', 'Norway': 'Noruega',
  'Argentina': 'Argentina', 'Algeria': 'Argelia', 'Austria': 'Austria',
  'Jordan': 'Jordania', 'Portugal': 'Portugal', 'Congo DR': 'Congo',
  'England': 'Inglaterra', 'Croatia': 'Croacia', 'Ghana': 'Ghana',
  'Panama': 'Panamá', 'Uzbekistan': 'Uzbekistán', 'Colombia': 'Colombia',
};

const BANDERA_KEY = {
  'Mexico': 'mexico', 'South Africa': 'sudafrica', 'Korea Republic': 'corea',
  'Czechia': 'czechia', 'Canada': 'canada', 'Bosnia-Herzegovina': 'bosnia',
  'USA': 'usa', 'Paraguay': 'paraguay', 'Qatar': 'qatar', 'Switzerland': 'suiza',
  'Brazil': 'brasil', 'Morocco': 'marruecos', 'Haiti': 'haiti', 'Scotland': 'escocia',
  'Australia': 'australia', 'Turkey': 'turquia', 'Germany': 'alemania',
  'Curaçao': 'curacao', 'Netherlands': 'paises-bajos', 'Japan': 'japon',
  "Côte d'Ivoire": 'costa-marfil', 'Ecuador': 'ecuador', 'Sweden': 'suecia',
  'Tunisia': 'tunez', 'Spain': 'espana', 'Cabo Verde': 'cabo-verde',
  'Belgium': 'belgica', 'Egypt': 'egipto', 'Saudi Arabia': 'arabia-saudita',
  'Uruguay': 'uruguay', 'IR Iran': 'iran', 'New Zealand': 'nueva-zelanda',
  'France': 'francia', 'Senegal': 'senegal', 'Iraq': 'irak', 'Norway': 'noruega',
  'Argentina': 'argentina', 'Algeria': 'argelia', 'Austria': 'austria',
  'Jordan': 'jordania', 'Portugal': 'portugal', 'Congo DR': 'congo',
  'England': 'inglaterra', 'Croatia': 'croacia', 'Ghana': 'ghana',
  'Panama': 'panama', 'Uzbekistan': 'uzbekistan', 'Colombia': 'colombia',
  // Español (nombres de la DB)
  'México':'mexico','Sudáfrica':'sudafrica','Corea del Sur':'corea',
  'Chequia':'czechia','Canadá':'canada','Bosnia y Herzegovina':'bosnia',
  'Estados Unidos':'usa','Qatar':'qatar','Suiza':'suiza',
  'Brasil':'brasil','Marruecos':'marruecos','Haití':'haiti','Escocia':'escocia',
  'Australia':'australia','Turquía':'turquia','Alemania':'alemania',
  'Países Bajos':'paises-bajos','Japón':'japon','Ecuador':'ecuador',
  'Suecia':'suecia','España':'espana','Bélgica':'belgica','Egipto':'egipto',
  'Arabia Saudita':'arabia-saudita','Uruguay':'uruguay','Irán':'iran',
  'Nueva Zelanda':'nueva-zelanda','Francia':'francia','Senegal':'senegal',
  'Iraq':'irak','Noruega':'noruega','Argentina':'argentina','Argelia':'argelia',
  'Austria':'austria','Portugal':'portugal','Inglaterra':'inglaterra',
  'Croacia':'croacia','Ghana':'ghana','Panamá':'panama','Colombia':'colombia',
  'DR Congo':'congo','Túnez':'tunez','Costa de Marfil':'costa-marfil',
  'Cabo Verde':'cabo-verde','Curazao':'curacao','Jordania':'jordania',
  'Uzbekistán':'uzbekistan','Paraguay':'paraguay',
};

const EMOJIS = {
  'Mexico':'🇲🇽','South Africa':'🇿🇦','Korea Republic':'🇰🇷','Czechia':'🇨🇿',
  'Canada':'🇨🇦','Bosnia-Herzegovina':'🇧🇦','USA':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Switzerland':'🇨🇭','Brazil':'🇧🇷','Morocco':'🇲🇦',
  'Haiti':'🇭🇹','Scotland':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turkey':'🇹🇷',
  'Germany':'🇩🇪','Curaçao':'🇨🇼','Netherlands':'🇳🇱','Japan':'🇯🇵',
  "Côte d'Ivoire":'🇨🇮','Ecuador':'🇪🇨','Sweden':'🇸🇪','Tunisia':'🇹🇳',
  'Spain':'🇪🇸','Cabo Verde':'🇨🇻','Belgium':'🇧🇪','Egypt':'🇪🇬',
  'Saudi Arabia':'🇸🇦','Uruguay':'🇺🇾','IR Iran':'🇮🇷','New Zealand':'🇳🇿',
  'France':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Norway':'🇳🇴',
  'Argentina':'🇦🇷','Algeria':'🇩🇿','Austria':'🇦🇹','Jordan':'🇯🇴',
  'Portugal':'🇵🇹','Congo DR':'🇨🇩','England':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croatia':'🇭🇷',
  'Ghana':'🇬🇭','Panama':'🇵🇦','Uzbekistan':'🇺🇿','Colombia':'🇨🇴',
  // Español
  'México':'🇲🇽','Sudáfrica':'🇿🇦','Corea del Sur':'🇰🇷','Chequia':'🇨🇿',
  'Canadá':'🇨🇦','Bosnia y Herzegovina':'🇧🇦','Estados Unidos':'🇺🇸','Paraguay':'🇵🇾',
  'Qatar':'🇶🇦','Suiza':'🇨🇭','Brasil':'🇧🇷','Marruecos':'🇲🇦',
  'Haití':'🇭🇹','Escocia':'🏴󠁧󠁢󠁳󠁣󠁴󠁿','Australia':'🇦🇺','Turquía':'🇹🇷',
  'Alemania':'🇩🇪','Países Bajos':'🇳🇱','Japón':'🇯🇵','Ecuador':'🇪🇨',
  'Suecia':'🇸🇪','España':'🇪🇸','Bélgica':'🇧🇪','Egipto':'🇪🇬',
  'Arabia Saudita':'🇸🇦','Uruguay':'🇺🇾','Irán':'🇮🇷','Nueva Zelanda':'🇳🇿',
  'Francia':'🇫🇷','Senegal':'🇸🇳','Iraq':'🇮🇶','Noruega':'🇳🇴',
  'Argentina':'🇦🇷','Argelia':'🇩🇿','Austria':'🇦🇹','Portugal':'🇵🇹',
  'Inglaterra':'🏴󠁧󠁢󠁥󠁮󠁧󠁿','Croacia':'🇭🇷','Ghana':'🇬🇭','Panamá':'🇵🇦',
  'Colombia':'🇨🇴','DR Congo':'🇨🇩','Túnez':'🇹🇳','Costa de Marfil':'🇨🇮',
  'Cabo Verde':'🇨🇻','Curazao':'🇨🇼','Jordania':'🇯🇴','Uzbekistán':'🇺🇿',
};

const Bandera = ({ equipo, size = 30 }) => {
  const [imgError, setImgError] = useState(false);
  const key = BANDERA_KEY[equipo];
  if (!key || imgError) {
    return <span style={{ fontSize: size * 0.65, lineHeight: 1, display: 'block', textAlign: 'center' }}>{EMOJIS[equipo] || ''}</span>;
  }
  return (
    <img src={'/banderas/' + key + '.jpg'} alt={NOMBRE_ES[equipo] || equipo} onError={() => setImgError(true)}
      style={{ width: size, height: Math.round(size * 0.67), objectFit: 'cover', borderRadius: 2, display: 'block', border: '1px solid rgba(255,255,255,0.08)' }} />
  );
};

const TZ = 'America/Argentina/Buenos_Aires';
const diaKey = (isoStr) => new Date(isoStr).toLocaleDateString('sv-SE', { timeZone: TZ });
const formatDiaHeader = (dateKey) => {
  const [y, m, d] = dateKey.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long' });
};
const formatHora = (isoStr) =>
  new Date(isoStr).toLocaleTimeString('es-AR', { timeZone: TZ, hour: '2-digit', minute: '2-digit', hour12: false }) + 'hs';

const RONDA_LABEL = {
  grupos: 'Grupo', octavos: 'Octavos', cuartos: 'Cuartos',
  semis: 'Semifinal', tercer_puesto: '3er Puesto', final: 'FINAL',
};

const FixtureMundial = ({ jornadaActiva = null }) => {
  const [jornadas, setJornadas] = useState([]);
  const [jornadaIdx, setJornadaIdx] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      // Traer todas las jornadas disponibles
      const { data: nombresJornadas } = await supabase
        .from('mundial_partidos')
        .select('jornada, jornada_nombre')
        .order('jornada', { ascending: true });

      if (!nombresJornadas?.length) { setLoading(false); return; }

      // Agrupar por jornada única
      const jornadasMap = {};
      nombresJornadas.forEach(p => {
        if (!jornadasMap[p.jornada]) jornadasMap[p.jornada] = p.jornada_nombre || `Jornada ${p.jornada}`;
      });
      const numeros = Object.keys(jornadasMap).map(Number).sort((a, b) => a - b);

      // Traer partidos de todas las jornadas
      const { data: todos } = await supabase
        .from('mundial_partidos')
        .select('*')
        .not('equipo_local', 'eq', '')
        .order('hora', { ascending: true });

      if (!todos?.length) { setLoading(false); return; }

      const arr = numeros.map(num => ({
        numero: num,
        nombre: jornadasMap[num],
        partidos: todos.filter(p => p.jornada === num),
      }));

      setJornadas(arr);
      // Ir a la jornada activa o la más próxima
      const hoy = new Date();
      let idx = 0;
      if (jornadaActiva) {
        idx = arr.findIndex(j => j.numero === jornadaActiva);
      } else {
        // Ir a la jornada con partidos futuros más próximos
        idx = arr.findIndex(j => j.partidos.some(p => new Date(p.hora) >= hoy));
      }
      setJornadaIdx(idx >= 0 ? idx : arr.length - 1);
      setLoading(false);
    };
    cargar();
  }, [jornadaActiva]);

  if (loading) return (
    <div style={{ background: '#080d14', border: '1px solid #1e293b', borderRadius: '10px', padding: '16px', color: '#475569', fontSize: '0.85rem', textAlign: 'center', height: '100%', boxSizing: 'border-box' }}>
      Cargando fixture...
    </div>
  );
  if (!jornadas.length) return null;

  const jornadaActual = jornadas[jornadaIdx];
  const hayPrev = jornadaIdx > 0;
  const hayNext = jornadaIdx < jornadas.length - 1;

  return (
    <div style={{ background: '#080d14', border: '1px solid #1e293b', borderRadius: '10px', padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: '8px', height: '100%', boxSizing: 'border-box', overflow: 'hidden' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
        <span style={{ color: '#ffffff', fontSize: '1.0rem', textTransform: 'uppercase', letterSpacing: '1.5px', flex: 1 }}>Mundial 2026</span>
        <button onClick={() => setJornadaIdx(i => i - 1)} disabled={!hayPrev} style={{ width: 24, height: 24, borderRadius: '50%', background: hayPrev ? '#1e293b' : 'transparent', border: '1px solid ' + (hayPrev ? '#334155' : '#1e293b'), color: hayPrev ? '#94a3b8' : '#1e293b', cursor: hayPrev ? 'pointer' : 'default', fontSize: '0.8rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, transition: '0.15s' }}>{'<'}</button>
        <button onClick={() => setJornadaIdx(i => i + 1)} disabled={!hayNext} style={{ width: 24, height: 24, borderRadius: '50%', background: hayNext ? '#1e293b' : 'transparent', border: '1px solid ' + (hayNext ? '#334155' : '#1e293b'), color: hayNext ? '#94a3b8' : '#1e293b', cursor: hayNext ? 'pointer' : 'default', fontSize: '0.8rem', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, transition: '0.15s' }}>{'>'}</button>
      </div>

      {/* Jornada actual — nombre en cyan */}
      <div style={{ background: '#0a0f19', borderRadius: '6px', padding: '5px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <span style={{ color: '#00f2ff', fontSize: '0.82rem', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }}>
          {jornadaActual.nombre}
        </span>
        <span style={{ color: '#475569', fontSize: '0.72rem' }}>
          {jornadaActual.partidos.length} partido{jornadaActual.partidos.length !== 1 ? 's' : ''}
        </span>
      </div>

      {/* Partidos */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px', overflowY: 'auto' }}>
        {jornadaActual.partidos.map(p => {
          const esEnVivo     = p.estado === 'en_vivo';
          const esFinalizado = p.estado === 'finalizado';
          const tieneScore   = p.goles_local !== null && p.goles_visitante !== null;
          // Grupo va abajo del marcador/hora, no arriba
          const etiqueta = p.ronda === 'grupos'
            ? 'Grupo ' + p.grupo
            : (RONDA_LABEL[p.ronda] || p.ronda);

          return (
            <div key={p.id} style={{ background: esEnVivo ? '#071a0e' : '#0a0f19', border: '1px solid ' + (esEnVivo ? '#22c55e44' : '#111827'), borderRadius: '8px', padding: '7px 8px', display: 'flex', alignItems: 'center', gap: '6px' }}>

              {/* Local */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', minWidth: 0 }}>
                <Bandera equipo={p.equipo_local} size={30} />
                <span style={{ color: esFinalizado ? '#d2d2d2' : '#cbd5e1', fontSize: '0.62rem', fontWeight: 'bold', textAlign: 'center', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {NOMBRE_ES[p.equipo_local] || p.equipo_local}
                </span>
              </div>

              {/* Centro: marcador arriba, grupo abajo */}
              <div style={{ flexShrink: 0, textAlign: 'center', minWidth: '52px' }}>
                {esEnVivo ? (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px', marginBottom: '2px' }}>
                    <div style={{ width: 5, height: 5, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 4px #22c55e' }} />
                    <span style={{ color: '#22c55e', fontSize: '0.95rem', fontWeight: 'bold' }}>{p.goles_local}:{p.goles_visitante}</span>
                  </div>
                ) : tieneScore ? (
                  <span style={{ color: '#d2d2d2', fontSize: '0.95rem', fontWeight: 'bold', display: 'block', marginBottom: '2px' }}>{p.goles_local}–{p.goles_visitante}</span>
                ) : (
                  <span style={{ color: '#d2d2d2', fontSize: '0.75rem', fontWeight: 'bold', display: 'block', marginBottom: '2px' }}>{formatHora(p.hora)}</span>
                )}
                <div style={{ color: '#d2d2d2', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.3px' }}>{etiqueta}</div>
              </div>

              {/* Visitante */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', minWidth: 0 }}>
                <Bandera equipo={p.equipo_visitante} size={30} />
                <span style={{ color: esFinalizado ? '#d2d2d2' : '#cbd5e1', fontSize: '0.62rem', fontWeight: 'bold', textAlign: 'center', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {NOMBRE_ES[p.equipo_visitante] || p.equipo_visitante}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Dots jornadas */}
      <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexShrink: 0 }}>
        {jornadas.map((j, i) => {
          const activo = i === jornadaIdx;
          return (
            <div key={j.numero} onClick={() => setJornadaIdx(i)} title={j.nombre}
              style={{ width: activo ? 14 : 5, height: 5, borderRadius: 3, background: activo ? '#00f2ff' : '#1e293b', cursor: 'pointer', transition: 'all 0.2s ease' }} />
          );
        })}
      </div>
    </div>
  );
};

export default FixtureMundial;